import { render, staticRenderFns } from "./RequisitionListTable.vue?vue&type=template&id=19a7c320&scoped=true"
import script from "./RequisitionListTable.vue?vue&type=script&lang=js"
export * from "./RequisitionListTable.vue?vue&type=script&lang=js"
import style0 from "./RequisitionListTable.vue?vue&type=style&index=0&id=19a7c320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7c320",
  null
  
)

export default component.exports